// polyfills that should get us at least IE10/11 support
import "core-js/es/map";
import "core-js/es/set";
import "core-js/es/symbol";
import "core-js/es/promise";
import "core-js/es/symbol/iterator";
import "core-js/es/object/assign";
import "core-js/es/string/replace-all";
import "raf/polyfill";
import { config } from "@fortawesome/fontawesome-svg-core";

import React from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

// address CSP issues with react-fontawesome
config.autoAddCss = false;

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
